import { atom } from 'recoil';

export const navigationBarState = atom({
  key: 'navigationBarState',
  default: {
    title: '',
    'left-item': null,
    'right-item': null,
  },
});